export default __webpack_public_path__ + "static/hero-animation-488346c9ab3f587c3e01463399ef8d15.gif";